module.exports = __webpack_public_path__ + "static/media/16UNODC3.e853f3f5.jpg";